import React, { ReactNode } from 'react';

import SidePanel from './SidePanel/SidePanel';
import Content from './Content/Content';

import './WorkspacesPreview.scss';

type PropType = {
  workspaceContent: ReactNode;
  useFirstWorkspaceIfNull?: boolean;
};

export default function WorkspacesPreview({ workspaceContent, useFirstWorkspaceIfNull }: PropType) {
  return (
    <div className="d-flex h-100">
      <SidePanel />
      <Content workspaceContent={workspaceContent} useFirstWorkspaceIfNull={useFirstWorkspaceIfNull} />
    </div>
  );
}
